import React from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons } from '@/js/libs/ui/src/V2';

import { ArrowButton, ArrowTrack } from './styles';

interface IScrollTop {
  offset: number;
}

const ScrollArrow: React.FC<IScrollTop> = ({ offset }) => {
  const [t] = useTranslation(['common']);
  const [showScroll, setShowScroll] = React.useState<boolean>(false);

  const checkScroll = useCallbackRef(() => {
    if (!showScroll && window.scrollY > offset) {
      setShowScroll(true);
    } else if (showScroll && window.scrollY <= offset) {
      setShowScroll(false);
    }
  });

  const scrollTop = useCallbackRef(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  React.useEffect(() => {
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, [checkScroll]);

  return (
    <CSSTransition in={showScroll} transitionAppear transitionAppearTimeout={500} timeout={150} unmountOnExit>
      <ArrowTrack $visible={showScroll}>
        <ArrowButton type='button' onClick={scrollTop} aria-label={t('common:BACK_TO_TOP')}>
          <Icons.Chevron alt direction='top' size={24} />
        </ArrowButton>
      </ArrowTrack>
    </CSSTransition>
  );
};

export default ScrollArrow;
